export var CobrowserErrors;
(function (CobrowserErrors) {
    CobrowserErrors[CobrowserErrors["Cancelled"] = 0] = "Cancelled";
})(CobrowserErrors || (CobrowserErrors = {}));
export class CobrowserError extends Error {
    constructor(type, message) {
        super(message);
        this.type = type;
        this.name = CobrowserErrors[type];
    }
}
//# sourceMappingURL=errors.js.map